import { render, staticRenderFns } from "./ModalCodeAccess.vue?vue&type=template&id=9a4c5e22&scoped=true"
import script from "./ModalCodeAccess.vue?vue&type=script&lang=js"
export * from "./ModalCodeAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4c5e22",
  null
  
)

export default component.exports